import { MAX_SELECTABLE_SERIES } from "~/feature/chart/constants";

export const maxLinesBanner = `Max ${MAX_SELECTABLE_SERIES} lines reached`;
